import type { SVGProps } from 'react';

const SvgPendle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.5655 8.10066C17.5655 9.9734 16.8646 11.7914 15.6051 13.1823C14.3457 14.5731 12.6153 15.4493 10.7426 15.6354C10.8302 14.5622 10.5016 13.4889 9.81166 12.6566C9.1217 11.8242 8.147 11.2876 7.07373 11.1562V1.12441C8.22366 0.642534 9.47216 0.445402 10.7207 0.565871C11.9582 0.68634 13.1519 1.10251 14.1923 1.79246C15.2328 2.48242 16.087 3.42427 16.6674 4.51944C17.2588 5.62557 17.5655 6.85216 17.5655 8.10066Z"
      fill="#DEDEDE"
    />
    <path
      d="M2.463 15.7668C2.38634 15.1316 2.463 14.4964 2.68204 13.894C2.90107 13.2917 3.24058 12.7551 3.70055 12.306C4.39051 13.3464 5.33235 14.1897 6.42753 14.7811C7.5227 15.3725 8.76024 15.6682 9.99779 15.6682C10.2497 15.6682 10.4906 15.6573 10.7425 15.6354C10.6549 16.6648 10.1949 17.6286 9.43925 18.3404C8.68358 19.0523 7.69793 19.4466 6.65751 19.4685C5.62805 19.4794 4.62049 19.118 3.84292 18.428C3.0763 17.7381 2.58347 16.7962 2.463 15.7668Z"
      fill="#1E4480"
    />
    <path
      d="M7.07381 1.13538V11.1562C8.14708 11.2767 9.13274 11.8133 9.81174 12.6566C10.5017 13.4889 10.8303 14.5622 10.7426 15.6355C10.5017 15.6574 10.2498 15.6683 9.99792 15.6683C8.74943 15.6683 7.52283 15.3617 6.42766 14.7812C5.33249 14.1898 4.39064 13.3465 3.70068 12.3061C4.35779 11.6709 5.21202 11.2657 6.12101 11.1672V1.6063C6.41671 1.43107 6.73431 1.2668 7.07381 1.13538Z"
      fill="#152E51"
    />
    <path
      d="M2.44112 8.10057C2.44112 6.78637 2.78062 5.50501 3.42677 4.36604C4.07292 3.22706 5.00382 2.27426 6.13185 1.6062V11.1561C5.22286 11.2547 4.36862 11.6599 3.70057 12.306C2.86824 11.0575 2.43017 9.60096 2.44112 8.10057Z"
      fill="#DEDEDE"
    />
  </svg>
);

export default SvgPendle;
